import { render, staticRenderFns } from "./BookingServiceSuccess.vue?vue&type=template&id=2440937c"
import script from "./BookingServiceSuccess.vue?vue&type=script&lang=js"
export * from "./BookingServiceSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports